/** @jsx jsx */
import React from 'react'
import { jsx, Grid } from 'theme-ui'

const CardList = (props) => {
  return (
    <Grid
      sx={{
        width: '100%',
        gridTemplateColumns: props.listStyle
          ? '1fr'
          : ['1 1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
        gridAutoRows: 'minmax(350px, auto)',
        justifyItems: 'center',
        gap: props.listStyle ? 65 : 16,
        position: 'relative',
        ...props.style,
      }}
    >
      {props.children}
    </Grid>
  )
}

export default CardList
